import config from "./config";
import { SubmitForm } from "@/types";

export const submitTest = (submitForm: { form: SubmitForm }) => {
  fetch(`${config.API_URL}${config.TEST_SUBMIT}${config.TOKEN}`, {
    method: "post",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(submitForm)
  }).then(entry => entry.json());
};
